import React from 'react'

import { DrawerUserDetail } from 'components/navigation/Nav/DrawerUserDetail'
import useAuth from 'hooks/use-auth'
import { getUserDisplayName } from 'utils/user'

export const DrawerUserInfo: React.FC = () => {
  const { companyDisplayName, companyId, currentTeam, currentTeamId, session } =
    useAuth()

  return (
    <>
      {getUserDisplayName(session) && (
        <DrawerUserDetail
          iconName="solidUser"
          text={getUserDisplayName(session)}
        />
      )}
      {currentTeam?.name && (
        <DrawerUserDetail
          clipboardOptions={{
            content: currentTeamId,
            tooltipText: `Copy Team ID: ${currentTeamId}`
          }}
          iconName="solidUserGroup"
          text={currentTeam?.name}
        />
      )}
      {companyDisplayName && (
        <DrawerUserDetail
          clipboardOptions={{
            content: companyId,
            tooltipText: `Copy Company ID: ${companyId}`
          }}
          iconName="solidBuilding"
          text={companyDisplayName}
        />
      )}
    </>
  )
}
